module.exports = "/img/item-10.0219ecbd.png";